const ENDPOINTS = {
  closing: '/employer_view/closing',
  success_fee: '/employer_view/success_fee',
  jwt: '/v1/users/jwt',
  token_refresh: '/v1/users/token/refresh',
  test: '/test',
};

export { ENDPOINTS };
